import React from 'react'
import ImageAvatar from './ImageAvatar'

const GroupAvatar = props => {
  return <ImageAvatar {...props} />
}

export default GroupAvatar
